<div class="delete-container">
  <img src="assets/exito.gif" alt="GIF" width="150" >
  <h1 class="fw-bold">Cuenta eliminada</h1>
  <p class="email-text-middle mt-1">
    Tu cuenta ha sido eliminada con éxito.
  </p>
</div>
